import { ArkModule } from "@skyslit/ark-react";
import { connect } from "react-redux";
import { ComponentMap } from "@skyslit/ark-react/build/types";
import ExamPageView from "./views/ExamPage.view";
import ExamPicker from './components/ExamPicker';

export type StateType = {};

export default class ExamModule extends ArkModule<StateType> {
  constructor() {
    super("ExamModule");

    this.useConnect(connect);

    this.getReducer = () => {
      return (state: StateType = this.initialState, action: any) => {
        switch (action.type) {
          default: {
            return state;
          }
        }
      };
    };

    this.main = () => {};
  }

  services = {
    addExam: (title: string, templateId: string) => {
      return new Promise((resolve, reject) => {
        this.getServiceProvider("Main")
          .post("/api/admin/exams", {
            title,
            templateId,
          })
          .then((response) => {
            resolve((response.data && response.data) || null);
          })
          .catch((err) => {
            reject((err.response && err.response && err.response.data) || err);
          });
      });
    },
    getAllExam: (
      templateId: string | null,
      params?: { page?: number; limit?: number; search?: string }
    ) => {
      return new Promise((resolve, reject) => {
        this.getServiceProvider("Main")
          .get(`/api/admin/exams${templateId ? `/${templateId}` : ""}`, {
            params: {
              page: params?.page ?? 0,
              limit: params?.limit ?? 100,
              search: params?.search ?? "",
            },
          })
          .then((response) => {
            resolve((response.data && response.data) || null);
          })
          .catch((err) => {
            reject((err.response && err.response && err.response.data) || err);
          });
      });
    },

    CopyImagesFromCampus: (id: string) => {
      return new Promise((resolve, reject) => {
        this.getServiceProvider("Main")
          .post("/api/exams/copy/campus",{id})
          .then((response) => {
            resolve((response.data && response.data) || null);
          })
          .catch((err) => {
            reject((err.response && err.response && err.response.data) || err);
          });
      });
    },
  };

  views: ComponentMap = {
    ExamPage: ExamPageView,
    ExamPicker: ExamPicker
  };

  initialState: StateType = {};
}
